export const venueStyle = {
    iconImage: 'venue',
    iconAnchor: 'bottom' as const,
    allowOverlap: true,
}
